import FormText from 'components/form/FormText';
import FormWysiwygEditor from 'components/form/FormWysiwygEditor';
import IndicatorButton from 'components/indicator/IndicatorButton';
import { DivConst } from 'constants/divConst';
import type { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import type { SettingCompanyFormStateType } from '../hooks/useSettingCompany';

import type { JSX } from 'react';

type Props = {
  register: UseFormRegister<SettingCompanyFormStateType>;
  errors: FieldErrors<SettingCompanyFormStateType>;
  control: Control<SettingCompanyFormStateType>;
  isAdmin: boolean;
  isTermsInputDivUrl: boolean;
  isTermsInputDivText: boolean;
  onPreviewTerms: () => void;
  onResetTerms: () => void;
  processingOnPreview: boolean;
};

/**
 * カンパニー設定 - 利用規約セクション
 */
export default function TermsSection({
  register,
  errors,
  control,
  isAdmin,
  isTermsInputDivUrl,
  isTermsInputDivText,
  onPreviewTerms,
  onResetTerms,
  processingOnPreview,
}: Props): JSX.Element {
  return (
    <div className="form-group">
      <h3 className="title-section title-md fw-bold">利用規約*</h3>
      <div className="row form-row flex-md-row justify-content-between mb-3">
        <div className="mt-4 col-left">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="termsInputDiv"
              id="termsInputDiv1"
              value={DivConst.items.termsInputType.url.value}
              {...register('termsInputDiv', { valueAsNumber: true })}
              checked={isTermsInputDivUrl}
            />
            <label className="form-check-label" htmlFor="termsInputDivUrl">
              URLで指定
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="termsInputDiv"
              id="termsInputDiv2"
              value={DivConst.items.termsInputType.text.value}
              {...register('termsInputDiv', { valueAsNumber: true })}
              checked={isTermsInputDivText}
            />
            <label className="form-check-label" htmlFor="termsInputDivText">
              テキストで指定
            </label>
          </div>
          <p className="mt-1">
            利用規約が記載されたページのURLまたは利用規約のテキストを入力してください
          </p>
        </div>
      </div>
      <div className="row form-row flex-md-row justify-content-between">
        <div className="column col-lg-6 col-xl-6 col-left">
          <FormText
            subject="利用規約のURL"
            name="termsUrl"
            placeholder="http://example.com/terms"
            register={register}
            errors={errors}
            maxLength={100}
            format={isTermsInputDivUrl ? 'url' : undefined}
            readOnly={!isAdmin}
            required={isTermsInputDivUrl}
            disabled={isTermsInputDivText}
          />
        </div>
      </div>
      <div className="row form-row flex-md-row justify-content-between">
        <div className="mt-4 col-left">
          <FormWysiwygEditor
            subject="利用規約のテキスト"
            name="termsText"
            placeholder="利用規約のテキスト"
            errors={errors}
            control={control}
            toolbar={['link']}
            readOnly={!isAdmin}
            required={isTermsInputDivText}
            disabled={isTermsInputDivUrl}
          />
        </div>
        <div className="d-flex gap-3">
          <a
            onClick={onPreviewTerms}
            className={`mb-2 ${isTermsInputDivUrl ? 'text-muted' : ''}`}
            style={{
              cursor: isTermsInputDivUrl ? 'not-allowed' : 'pointer',
              pointerEvents: isTermsInputDivUrl ? 'none' : 'auto',
            }}
          >
            <IndicatorButton visible={processingOnPreview} />
            プレビュー
          </a>
          <a
            onClick={onResetTerms}
            className={`mb-2 ${isTermsInputDivUrl ? 'text-muted' : ''}`}
            style={{
              cursor: isTermsInputDivUrl ? 'not-allowed' : 'pointer',
              pointerEvents: isTermsInputDivUrl ? 'none' : 'auto',
            }}
          >
            リセット
          </a>
        </div>
      </div>
    </div>
  );
}
